import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import DiagnosticView from "@/pages/DiagnosticView";

export const Route = createFileRoute("/cuenta/historial/diagnostico/$sessionId")({
  component: () => (
    <ProtectedRoute>
      <DiagnosticView />
    </ProtectedRoute>
  ),
});
